import { style } from "@vanilla-extract/css";

export const formStyle = style({
  width: "100%",
});
